import { Fragment } from "react";

const inline = (s) => s.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((p, i) =>
  p.startsWith("**") && p.endsWith("**") ? <strong key={i} className="font-semibold text-slate-900">{p.slice(2, -2)}</strong>
    : p.startsWith("`") && p.endsWith("`") ? <code key={i} className="rounded bg-slate-100 px-1 font-mono text-[12px]">{p.slice(1, -1)}</code>
      : <Fragment key={i}>{p.replace(/(^|\s)\*([^*]+)\*(?=\s|$|[.,!?])/g, "$1$2")}</Fragment>);

export function Markdown({ text }) {
  const out = [];
  let list = null;
  const flush = () => { if (list) { out.push(list.ordered ? <ol key={`ol-${out.length}`} className="my-1 list-decimal space-y-0.5 pl-5">{list.items}</ol> : <ul key={`ul-${out.length}`} className="my-1 list-disc space-y-0.5 pl-5">{list.items}</ul>); list = null; } };
  text.split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    const b = line.match(/^\s*[-*•]\s+(.*)/), n = line.match(/^\s*\d+[.)]\s+(.*)/), h = line.match(/^(#{1,4})\s+(.*)/);
    if (b || n) {
      const ordered = !!n;
      if (!list || list.ordered !== ordered) { flush(); list = { ordered, items: [] }; }
      list.items.push(<li key={i}>{inline((b || n)[1])}</li>);
      return;
    }
    flush();
    if (h) out.push(<p key={`h-${i}`} className="mt-2 font-semibold text-slate-900 first:mt-0">{inline(h[2])}</p>);
    else if (line.trim()) out.push(<p key={`p-${i}`} className="my-1 first:mt-0">{inline(line)}</p>);
  });
  flush();
  return <div className="text-sm leading-relaxed" data-testid="agyin-markdown">{out}</div>;
}
